import { useState } from 'react';
import { updateJobCharge } from '../api/jobCharges';
import type { UpdateJobChargeRequest, JobCharge } from '../types/jobCharge';

/**
 * Hook for updating an existing job charge
 */
export function useUpdateJobCharge() {
  const [isUpdating, setIsUpdating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const update = async (
    jobId: number,
    chargeId: number,
    data: UpdateJobChargeRequest
  ): Promise<JobCharge | null> => {
    setIsUpdating(true);
    setError(null);
    try {
      const charge = await updateJobCharge(jobId, chargeId, data);
      return charge;
    } catch (err) {
      const error = err as { response?: { data?: { message?: string } } };
      setError(error.response?.data?.message || 'Failed to update job charge');
      return null;
    } finally {
      setIsUpdating(false);
    }
  };

  return {
    update,
    isUpdating,
    error,
  };
}
